














import { computed, defineComponent } from '@vue/composition-api';

const options = [
	{
		label: 'Field Name',
		value: { sortBy: 'name', sortDir: 'ASC' },
	},
	{
		label: 'Group',
		value: { sortBy: 'groupName', sortDir: 'ASC' },
	},
	{
		label: 'Producer',
		value: { sortBy: 'producerName', sortDir: 'ASC' },
	},
	{
		label: 'Status',
		value: { sortBy: 'status', sortDir: 'DESC' },
	},
];

export default defineComponent({
	setup(_, { root }) {
		const sortBy = computed(() => root.$store.getters['fieldsView/getSortBy']);
		const sortDir = computed(() => root.$store.getters['fieldsView/getSortDir']);
		const currentRadioValue = computed(
			() =>
				options.find((option) => sortBy.value === option.value.sortBy && sortDir.value === option.value.sortDir)
					?.value || null
		);
		const handleRadioChange = (event: any) => {
			root.$store.dispatch('fieldsView/changeSort', event);
		};
		const clearFilter = () => {
			root.$store.dispatch('fieldsView/changeSort', { sortBy: null, sortDir: null });
		};

		return {
			currentRadioValue,
			handleRadioChange,
			clearFilter,
			options,
		};
	},
});
